//* clp-slider *//
document.addEventListener('DOMContentLoaded', function () {
    for (let i = 0; i < 5; i++) {
        document.querySelectorAll('.swiper-' + i).forEach(function (swiperEl) {
            const swiperInstance = new Swiper(swiperEl, {
                slidesPerView: 2.1,
                spaceBetween: 24,
                lazy: {
                    loadPrevNext: true,
                    loadOnTransitionStart: true,
                },
                watchSlidesVisibility: true,
                preloadImages: false,
                navigation: {
                    nextEl: swiperEl.querySelector('.swiper-button-next'),
                    prevEl: swiperEl.querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: swiperEl.querySelector(".swiper-pagination"),
                    type: "progressbar",
                    clickable: true,
                    enabled: true
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2.1,
                        spaceBetween: 24,
                    },
                    991: {
                        slidesPerView: 3.1,
                        spaceBetween: 15,
                        simulateTouch: true,
                        allowTouchMove: true,
                        shortSwipes: true,
                        pagination: {
                            enabled: false
                        }
                    }
                },
                loop: false,
                on: {
                    slideChange: function () {
                        const swiper = this;
                        const prevBtn = swiper.navigation.prevEl;
                        const nextBtn = swiper.navigation.nextEl;

                        if (swiper.isBeginning) {
                            prevBtn.classList.add('swiper-button-lock');
                        } else {
                            prevBtn.classList.remove('swiper-button-lock');
                        }

                        if (swiper.isEnd) {
                            nextBtn.classList.add('swiper-button-lock');
                        } else {
                            nextBtn.classList.remove('swiper-button-lock');
                        }
                    },
                    init: function () {
                        const swiper = this;
                        const prevBtn = swiper.navigation.prevEl;
                        const nextBtn = swiper.navigation.nextEl;

                        if (swiper.isBeginning) {
                            prevBtn.classList.add('swiper-button-lock');
                        }
                        if (swiper.isEnd) {
                            nextBtn.classList.add('swiper-button-lock');
                        }
                    }
                }
            });
        });
    }

    document.querySelectorAll('.view-more-slide').forEach(function (slide) {
        const nextButton = slide.parentElement.nextElementSibling?.querySelector('.swiper-button-next');
        if (slide.classList.contains('swiper-slide-active')) {
            nextButton?.classList.toggle('no-click');
        } else {
            nextButton?.classList.remove('no-click');
        }
    });

    document.querySelectorAll('.swiper-slide #swatch-swiper-js').forEach(function (swiperEl) {
        const swiper = new Swiper(swiperEl, {
            init: false,
            slidesPerView: 4,
            slidesPerGroup: 4,
            navigation: {
                nextEl: swiperEl.parentElement.querySelector('.swatch-swiper-button-next'),
                prevEl: swiperEl.parentElement.querySelector('.swatch-swiper-button-prev')
            },
            spaceBetween: 4,
            breakpointsBase: 'window',
            breakpoints: {
                768: {
                    slidesPerView: 5,
                    slidesPerGroup: 5
                },
                1280: {
                    slidesPerView: 6,
                    slidesPerGroup: 6
                },
                1499: {
                    slidesPerView: 7,
                    slidesPerGroup: 7
                }
            },
            on: {
                resize: function () {
                    if (swiperEl.parentElement.querySelector('.swiper-button-lock')) {
                        swiperEl.classList.add('swiper-no-scroll');
                    } else {
                        swiperEl.classList.remove('swiper-no-scroll');
                    }
                }
            }
        });
        swiper.on('init', function (swiper) {
            if (swiper.el.parentElement.querySelector('.swiper-button-lock')) {
                swiper.el.classList.add('swiper-no-scroll');
            }
        });
        swiper.init();
    });

    document.querySelectorAll('.c-collection-grid__item #swatch-swiper-js').forEach(function (swiperEl) {
        const swiper = new Swiper(swiperEl, {
            init: false,
            slidesPerView: 4,
            slidesPerGroup: 4,
            navigation: {
                nextEl: swiperEl.parentElement.querySelector('.swatch-swiper-button-next'),
                prevEl: swiperEl.parentElement.querySelector('.swatch-swiper-button-prev')
            },
            spaceBetween: 4,
            breakpointsBase: 'window',
            on: {
                resize: function () {
                    if (swiperEl.parentElement.querySelector('.swiper-button-lock')) {
                        swiperEl.classList.add('swiper-no-scroll');
                    } else {
                        swiperEl.classList.remove('swiper-no-scroll');
                    }
                }
            },
            breakpoints: {
                768: {
                    slidesPerView: 5,
                    slidesPerGroup: 5
                },
                1280: {
                    slidesPerView: 6,
                    slidesPerGroup: 6
                },
                1499: {
                    slidesPerView: 7,
                    slidesPerGroup: 7
                }
            }
        });

        swiper.on('init', function (swiper) {
            if (swiper.el.parentElement.querySelector('.swiper-button-lock')) {
                swiper.el.classList.add('swiper-no-scroll');
            }
        });
        // init Swiper
        swiper.init();
    });
});